// extracted by mini-css-extract-plugin
module.exports = {"app":"zeus_zeus_zeus_power_center_detail_app__Up3OR"};